var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _vm.popupParam.fireDetectionId
                  ? _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm revisionLayout",
                        attrs: { title: "LBLREV", topClass: "topcolor-orange" },
                      },
                      [
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-1" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "LBLREVNO",
                                        name: "revisionNum",
                                      },
                                      model: {
                                        value: _vm.data.revisionNum,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "revisionNum", $$v)
                                        },
                                        expression: "data.revisionNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-2" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "LBLREVPERIOD",
                                        name: "regDtStr",
                                      },
                                      model: {
                                        value: _vm.data.regDtStr,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "regDtStr", $$v)
                                        },
                                        expression: "data.regDtStr",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-1" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "LBLREVUSER",
                                        name: "regUserName",
                                      },
                                      model: {
                                        value: _vm.data.regUserName,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "regUserName", $$v)
                                        },
                                        expression: "data.regUserName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-4" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "LBLREVREASON",
                                        name: "revisionContent",
                                      },
                                      model: {
                                        value: _vm.data.revisionContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.data,
                                            "revisionContent",
                                            $$v
                                          )
                                        },
                                        expression: "data.revisionContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "LBL0010528" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-select" },
                      [
                        _vm.popupParam.fireDetectionId
                          ? _c("c-select", {
                              attrs: {
                                editable: !_vm.isRevision,
                                comboItems: _vm.gridrev.data,
                                type: "custom",
                                typetext: "LBL0010565",
                                itemText: "revisionNum",
                                itemValue: "fireDetectionId",
                                name: "selectedfireDetectionId",
                                label: "",
                              },
                              on: { input: _vm.rowClickRev },
                              model: {
                                value: _vm.selectedfireDetectionId,
                                callback: function ($$v) {
                                  _vm.selectedfireDetectionId = $$v
                                },
                                expression: "selectedfireDetectionId",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _c(
                              "q-btn",
                              {
                                staticClass: "custom-btn",
                                attrs: {
                                  icon: "help",
                                  color: "deep-purple-6",
                                  "text-color": "white",
                                  align: "center",
                                  round: "",
                                },
                              },
                              [
                                _c(
                                  "q-tooltip",
                                  {
                                    attrs: {
                                      anchor: "bottom left",
                                      self: "top left",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tooltipCustomTop" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$label("LBL0010385")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "tooltipCustom" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$message("MSG0010052"))
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$message("MSG0010053")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.fireDetectionId &&
                                    !_vm.isRevision,
                                  expression:
                                    "editable && popupParam.fireDetectionId && !isRevision",
                                },
                              ],
                              attrs: { label: "LBLREV", icon: "restart_alt" },
                              on: { btnClicked: _vm.SetRevision },
                            }),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.fireDetectionId &&
                                    _vm.isRevision,
                                  expression:
                                    "editable && popupParam.fireDetectionId && isRevision",
                                },
                              ],
                              attrs: {
                                label: "LBLREVCANCEL",
                                icon: "restart_alt",
                              },
                              on: { btnClicked: _vm.CancelRevision },
                            }),
                            _vm.editable && _vm.popupParam.fireDetectionId
                              ? _c("c-btn", {
                                  attrs: { label: "LBLREMOVE", icon: "remove" },
                                  on: { btnClicked: _vm.deleteData },
                                })
                              : _vm._e(),
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: {
                                    url: _vm.saveUrl,
                                    isSubmit: _vm.isSave,
                                    param: _vm.data,
                                    mappingType: _vm.mappingType,
                                    label: "LBLSAVE",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveData,
                                    btnCallback: _vm.saveCallback,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "LBL0010501",
                              name: "installLocation",
                            },
                            model: {
                              value: _vm.data.installLocation,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "installLocation", $$v)
                              },
                              expression: "data.installLocation",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              type: "edit",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.data.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "plantCd", $$v)
                              },
                              expression: "data.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-process", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0001705",
                              multiple: "single",
                              name: "processCd",
                            },
                            model: {
                              value: _vm.data.processCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "processCd", $$v)
                              },
                              expression: "data.processCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-dept", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0001721",
                              name: "deptCd",
                            },
                            model: {
                              value: _vm.data.deptCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deptCd", $$v)
                              },
                              expression: "data.deptCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010519",
                              name: "singleAlarm",
                            },
                            model: {
                              value: _vm.data.singleAlarm,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "singleAlarm", $$v)
                              },
                              expression: "data.singleAlarm",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010520",
                              name: "emergencyAlarm",
                            },
                            model: {
                              value: _vm.data.emergencyAlarm,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "emergencyAlarm", $$v)
                              },
                              expression: "data.emergencyAlarm",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010521",
                              name: "startAlarm",
                            },
                            model: {
                              value: _vm.data.startAlarm,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "startAlarm", $$v)
                              },
                              expression: "data.startAlarm",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010522",
                              name: "autoDetection",
                            },
                            model: {
                              value: _vm.data.autoDetection,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "autoDetection", $$v)
                              },
                              expression: "data.autoDetection",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010523",
                              name: "emergencyBroadcast",
                            },
                            model: {
                              value: _vm.data.emergencyBroadcast,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "emergencyBroadcast", $$v)
                              },
                              expression: "data.emergencyBroadcast",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010524",
                              name: "autoBreakingnews",
                            },
                            model: {
                              value: _vm.data.autoBreakingnews,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "autoBreakingnews", $$v)
                              },
                              expression: "data.autoBreakingnews",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010525",
                              name: "integrationSystem",
                            },
                            model: {
                              value: _vm.data.integrationSystem,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "integrationSystem", $$v)
                              },
                              expression: "data.integrationSystem",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010526",
                              name: "shortAlarm",
                            },
                            model: {
                              value: _vm.data.shortAlarm,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "shortAlarm", $$v)
                              },
                              expression: "data.shortAlarm",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }